export function authFetch(url, options = {}) {

  const token = localStorage.getItem("accessToken");

  return fetch(url,{
    ...options,
    headers:{
      ...(options.headers || {}),
      Authorization:`Bearer ${token}`
    }
  }).then(res=>{

    if(res.status === 401){
      localStorage.clear();
      window.location.reload();
      return;
    }

    return res.json();
  });
}